import(/* webpackMode: "eager" */ "/src/src/app/error.tsx");
